<template>
  <BaseParagraph
    :value="getValue"
    :ellipsis="ellipsis"
    :class="$attrs.class"
    :style="$attrs.style"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import type { EllipsisConfig } from 'ant-design-vue/es/typography/Base';
  import { isArray } from '@mts-fe/utils';
  import { BaseParagraph } from '@mts/components/Base';

  defineOptions({ name: 'LongText', inheritAttrs: false });

  const props = withDefaults(
    defineProps<{
      value?: string | number | string[] | number[];
      ellipsis?: EllipsisConfig;
    }>(),
    { ellipsis: () => ({ rows: 1 }) },
  );

  const getValue = computed(() => {
    return isArray(props.value)
      ? props.value.map((value) => value?.toString() ?? '-').join(' , ')
      : (props.value?.toString() ?? '-');
  });
</script>
